'use client';

import { usePathname } from 'next/navigation';

export default function BackToTopButton() {
  const pathname = usePathname();

  // Hide on all admin pages
  if (pathname?.startsWith('/admin')) {
    return null;
  }

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="w-full flex justify-center py-6 bg-deep-navy">
      <button
        onClick={scrollToTop}
        aria-label="Back to top"
        className="flex items-center gap-2 text-white/50 hover:text-white text-sm transition-colors duration-200 group"
      >
        <svg
          width="16"
          height="16"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          className="group-hover:-translate-y-0.5 transition-transform duration-200"
        >
          <polyline points="18 15 12 9 6 15" />
        </svg>
        Back to Top
      </button>
    </div>
  );
}
